import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import CoreAdvantagesContent from '@/pages/about/components/CoreAdvantagesContent';

export default function CorePage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '核心理念｜回歸自然，守護健康｜康永生技',
    description: '康永生技的品牌核心理念：回歸自然本質，嚴格追溯天然原料來源，以顧問式夥伴關係與品牌共同打造經得起市場考驗的保健食品。',
    keywords: '康永核心理念,天然原料,保健食品理念,品牌夥伴,自然健康',
    lang: 'zh-TW',
    canonicalPath: '/home/core',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="核心理念｜回歸自然，守護健康｜康永生技" pageDescription="康永生技的品牌核心理念：回歸自然本質，嚴格追溯天然原料來源，以顧問式夥伴關係與品牌共同打造經得起市場考驗的保健食品。" pageUrl={`${siteUrl}/home/core`} />
      <CoreAdvantagesContent />
    </Layout>
  );
}